export default __webpack_public_path__ + "static/media/user_interface_.117fb8cb.svg";